import * as serverReq from "./pendingActionsCrud";
import {pendingActionsSlice} from "./pendingActionsSlice";
import {errorMessage} from "../../../../util/Helpers"

const {actions} = pendingActionsSlice;


/* Api Request Error Handler */
const errorHandler = dispatch => error => {
  
  dispatch(actions.pendingActionNotification({ notification: {type: "error", message: errorMessage(error)}}));
}

export const clearNotification = _ => dispatch => dispatch(actions.pendingActionNotification({notification: null}));

/* Load PendingActions Action */
export const fetchPendingActions = _ => dispatch => {
  serverReq.getAllPendingActions()
            .then(({data}) =>  dispatch(actions.pendingActionsFetched([ ...data ])))
            .catch(errorHandler(dispatch));
};

/* Update existing pending Action */
export const confirmPendingAction = pendingActionData => dispatch => {
  serverReq.confirmPendingAction(pendingActionData)
            .then(({data}) => {
              dispatch(actions.pendingActionConfirmed({...data}));
              dispatch(fetchPendingActions());
            })
            .catch(errorHandler(dispatch));
};

/* Delete existing pendingAction Action */
export const deletePendingAction = id => dispatch => {
  serverReq.deletePendingAction(id)
            .then(({data}) => {
              dispatch(actions.pendingActionDeleted({ ...data }));
              dispatch(fetchPendingActions());
            })
            .catch(errorHandler(dispatch));
};

/* Fetch Action Document */
export const fetchDocument = path => dispatch => {
  dispatch(actions.documentFetched({ document: null }));
  serverReq.getDocument(path)
            .then(({data}) =>  dispatch(actions.documentFetched({ ...data })))
            .catch(errorHandler(dispatch));
};
